'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { FiSearch } from 'react-icons/fi';

interface SearchViewProps {
  placeholder?: string;
  onSearch?: (searchTerm: string) => void;
  className?: string;
}

const SearchView: React.FC<SearchViewProps> = ({ 
  placeholder = 'Search', 
  onSearch, 
  className = '',
  ...props
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleSearch = (): void => {
    if (onSearch) {
      onSearch(searchValue);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchValue(e.target.value);
  };

  return (
    <div data-component-id="src/components/ui/SearchView.tsx:38:4" data-component-path="src/components/ui/SearchView.tsx" data-component-line="38" data-component-file="SearchView.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" className={`
      flex flex-row items-center
      bg-global-5
      rounded-[19px]
      shadow-lg
      px-6 py-2
      ${className}
    `.trim().replace(/\s+/g, ' ')} {...props}>
      <input data-component-id="src/components/ui/SearchView.tsx:46:6" data-component-path="src/components/ui/SearchView.tsx" data-component-line="46" data-component-file="SearchView.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchValue%5D%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20flex-1%5Cn%20%20%20%20%20%20%20%20%20%20bg-transparent%5Cn%20%20%20%20%20%20%20%20%20%20text-searchview-1%5Cn%20%20%20%20%20%20%20%20%20%20font-dm-sans%5Cn%20%20%20%20%20%20%20%20%20%20text-base%5Cn%20%20%20%20%20%20%20%20%20%20leading-5%5Cn%20%20%20%20%20%20%20%20%20%20outline-none%5Cn%20%20%20%20%20%20%20%20%20%20placeholder-searchview-1%5Cn%20%20%20%20%20%20%20%20%22%7D"
        type="text"
        value={searchValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        className="
          flex-1
          bg-transparent
          text-searchview-1
          font-dm-sans
          text-base
          leading-5
          outline-none
          placeholder-searchview-1
        "
      />
      <button data-component-id="src/components/ui/SearchView.tsx:63:6" data-component-path="src/components/ui/SearchView.tsx" data-component-line="63" data-component-file="SearchView.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22ml-4%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-global-6%20focus%3Aring-opacity-50%20rounded%22%7D" 
        onClick={handleSearch} 
        className="ml-4 focus:outline-none focus:ring-2 focus:ring-global-6 focus:ring-opacity-50 rounded"
        aria-label="Search"
      >
        <FiSearch data-component-id="src/components/ui/SearchView.tsx:68:8" data-component-path="src/components/ui/SearchView.tsx" data-component-line="68" data-component-file="SearchView.tsx" data-component-name="FiSearch" data-component-content="%7B%22elementName%22%3A%22FiSearch%22%2C%22className%22%3A%22w-4%20h-4%20text-primaryColor%22%7D" className="w-4 h-4 text-primaryColor" />
      </button>
    </div>
  );
};

export default SearchView;